var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommission({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#827c78",
    strokeWidth: 0.54,
    d: "M30.35 21.404c-.412-.358-.958-.506-1.485-.412l-11.06 1.976-3.141-3.227c-.105-.108-.246-.168-.395-.168H8.692c0-.316-.249-.573-.557-.573H2v1.146h3.346v8.02H2v1.146h6.134c.309 0 .558-.257.558-.573h1.542l5.962 3.063c.258.132.537.199.816.198.317 0 .634-.085.918-.256l12.167-7.29c.557-.335.903-.955.903-1.617 0-.554-.237-1.077-.65-1.433zM7.578 28.166H6.462v-8.02h1.115v8.02zm21.957-4.701l-12.166 7.29c-.207.123-.458.132-.673.022l-6.08-3.123c-.077-.04-.163-.06-.25-.06H8.692v-6.875h5.346l4.394 4.513c.193.198.299.461.299.74 0 .579-.458 1.048-1.02 1.048-.268 0-.53-.111-.72-.307l-2.885-2.962-.789.81 2.885 2.962c.403.415.938.643 1.51.643 1.176 0 2.134-.983 2.134-2.193 0-.586-.222-1.136-.625-1.551l-.451-.464 10.286-1.837c.207-.038.416.021.577.16.16.138.252.34.252.556 0 .257-.135.497-.351.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9H22V10H14z",
    transform: "rotate(-47.724 18 9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10c.827 0 1.5-.673 1.5-1.5S16.327 7 15.5 7 14 7.673 14 8.5s.673 1.5 1.5 1.5zm0-2c.276 0 .5.225.5.5s-.224.5-.5.5-.5-.225-.5-.5.224-.5.5-.5zM19 11.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5-1.5.673-1.5 1.5zm2 0c0 .275-.224.5-.5.5s-.5-.225-.5-.5.224-.5.5-.5.5.225.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#827c78",
    strokeWidth: 0.54,
    d: "M17.6 21.828c.105.11.25.172.4.172.15 0 .295-.062.4-.172l8.726-9.234c2.499-2.645 2.499-6.948 0-9.592C25.906 1.71 24.282 1 22.553 1c-1.72 0-3.336.703-4.553 1.98C16.783 1.704 15.167 1 13.447 1c-1.729 0-3.353.71-4.573 2.002-2.499 2.645-2.499 6.948 0 9.592l8.727 9.234zM9.674 3.763c1.01-1.07 2.35-1.658 3.774-1.658 1.425 0 2.765.589 3.774 1.658l.38.401c.208.22.59.22.798 0l.38-.401c1.01-1.07 2.35-1.658 3.774-1.658s2.764.589 3.774 1.658c2.103 2.224 2.103 5.845 0 8.07L18 20.644l-8.327-8.81c-2.103-2.226-2.103-5.846 0-8.071z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.42cbfd515ade8c4150becbb0da6aea8d.svg";
export { ForwardRef as ReactComponent };